var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"member",attrs:{"to":{ name: 'user-card', params: {
    company: _vm.user.company.company,
    username: _vm.user.username
  }}}},[_c('div',{staticClass:"member__content"},[_c('Avatar',{attrs:{"src":_vm.user.avatar}}),_c('span',{staticClass:"member__name"},[_vm._v(_vm._s(_vm.user.name))])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }